export interface CustomerData {
  id?: number;
  phone: string;
  name: string;
  ageSegment: string;
  email: string;
  gender: string;
  zipcode: string;
}

export const emptyCustomerData: CustomerData = {
  phone: "",
  name: "",
  ageSegment: "",
  email: "",
  gender: "",
  zipcode: "",
};
